

  <c-card *transloco="let t" class="home-page">
    <c-card-body class="px-2">

      @if(showOrderNowTandCs()){
      
      <!-- Terms and Conditions Modal -->
      <div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="termsModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" *ngIf="showOrderNowTandCs()">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="termsModalLabel">{{ t('Please read and agree to our terms and conditions:') }}</h5>
            </div>
            <div class="modal-body">
              <div [innerHTML]="getTermsAndConditionsHtml()"></div>
            </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-info text-white" (click)="agreeToTerms()">
                  {{ t('I Agree') }}
                </button>
              </div>
          </div>
        </div>
      </div>

      }


      <ng-container *ngIf="showOrderNowWelcome()">
        <div class="alert alert-success" role="alert">
          <button type="button" class="btn btn-outline-secondary float-end bg-white"  (click)="okService.doDismissDb('order_now_welcome')">{{ t('Close') }}</button>
  
          <strong>Welcome to Ok Alone!</strong> Your account has been set up. Within the next 2 working days, a member of the OK Alone team will reach out to finalize the account setup and start onboarding. Alternatively, you can email us <a href="mailto: customer.support@okalone.net">customer.support&#64;okalone.net</a>.
  
        </div>
    
      </ng-container>

    <ng-container *ngIf="showDemoVideo()">

      <div class="alert alert-info" role="alert">
        <button type="button" class="btn btn-outline-secondary float-end bg-white"  (click)="okService.doDismissDb('dash_demo_video1')">{{ t('Close') }}</button>
        <b>{{ t('New to OK Alone?') }}</b> {{ t('View our short introduction video to learn about OK Alone') }} &nbsp;
        <button type="button" class="btn btn-info text-white"  data-bs-toggle="modal" data-bs-target="#videoModal"><i class="fa-brands fa-youtube"></i> {{ t('View Video') }}</button>
      </div>

      <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-body">

              <div class="embed-container"><iframe src="https://www.youtube.com/embed/PBWETStHmHw?si=CX_EGt9YhN7OPpaM" frameborder="0" allowfullscreen></iframe></div>


            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary float-end bg-white" data-bs-dismiss="modal" (click)="okService.doDismissDb('dash_demo_video1')">{{ t('Close') }}</button>
            </div>
          </div>
        </div>
      </div>

  </ng-container>




  <ng-container *ngIf="show2fa() && !okService.isFromAdmin()">
    <div class="alert alert-info" role="alert">
      <button type="button" class="btn btn-outline-secondary float-end bg-white align-self-center" (click)="okService.doDismissDb('2fa_notice')">{{ t('Close') }}</button>
      <b>{{ t("Multi-Factor Authentication: ") }}</b>{{ ("Your company has Multi-Factor Authentication turned on. Please go to your Monitor Settings and make sure you have Multi-Factor  turned on and a valid phone number and/or email for the dashboard.") }} <button *ngIf="okService.isAdmin()"  type="button" class="btn btn-info text-white"  routerLink="/mgmt/monitor/{{okService.session.id}}">{{ t('Go Now') }}</button>

    </div>
  </ng-container>

    <ng-container *ngIf="password_change_due && !okService.isFromAdmin()">

      <div class="alert alert-warning" role="alert">
        <b>{{ t('It\'s time to change your password') }}</b> {{ t('Please change your password now') }} &nbsp;
        <button type="button" class="btn btn-info text-white" routerLink="/settings/profile"> {{ t('Change your Password Now') }}</button>
      </div>

    </ng-container>

      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 mb-2">

          <div class="card" *ngIf="view!='map'">
            <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Workers') }}

              <div class="float-end" *ngIf="filter_active">
                <button type="button" class="btn btn-warning btn-sm text-white" data-bs-toggle="collapse" data-bs-target="#collapseExample">
                  <i class="fa-solid fa-triangle-exclamation"></i> {{ t('Filter Active') }}
                </button>
              </div>
            </div>
            <div class="collapse" id="collapseExample">
              <div class="card-body">

                <form cForm >

                  <div class="row mb-3">
                    <label  class="col-sm-4 col-form-label text-end" for="search">
                      <b>{{ t('Search') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <input cFormControl id="search" name="search" placeholder="{{ t('Search') }}" [(ngModel)]="search"/>
                    </div>
                  </div>



                  <div class="row mb-3">
                    <label  class="col-sm-4 col-form-label text-end" for="monitors">
                      <b>{{ t('Shown Workers') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <select aria-label="Default select example" name="monitors" cSelect [(ngModel)]="monitor">
                        <option value="all">{{ t('All Workers') }}</option>
                        <option value="mine">{{ t('My Monitored') }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row mb-3"  *ngIf="groups.length> 0 && okService.hasFeature('groups')">
                    <label  class="col-sm-4 col-form-label text-end" for="monitors">
                      <b>{{ t('Worker Group') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <ng-select
                      [items]="groups"
                      name="group"
                      [(ngModel)]="group"
                      bindLabel="name"
                      bindValue="id">
                    </ng-select>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <label  class="col-sm-4 col-form-label text-end" for="status">
                      <b>{{ t('Worker Status') }}</b>
                    </label>
                    <div class="col-sm-6">
                      <select aria-label="Default select example" name="status" cSelect [(ngModel)]="status">
                        <option value="all">{{ t('All Workers') }}</option>
                        <option value="working">{{ t('Working Only') }}</option>
                        <option value="not_working">{{ t('Not Working Only') }}</option>
                      </select>
                    </div>

                  </div>


                  <button cButton class="btn btn-primary" type="submit"  (click)="updateFilter()">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <span class="d-none d-lg-inline">
                        {{ t('Search') }}
                    </span>
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                      <i class="fa-solid fa-xmark"></i>
                    <span class="d-none d-lg-inline">
                       {{ t('Clear Filter') }}
                    </span>
                  </button>


                </form>

              </div>
            </div>
          </div>
        </div>






        <div class="col-lg-6 col-md-12 col-sm-12" *ngIf="view!='map'">

          <div class="row  text-end justify-content-end">
            <c-col xs="auto" *ngIf="pagination.totalPages > 1">
              <c-input-group  class="text-end mb-2">
                <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                  <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                </select>
              </c-input-group>
            </c-col>
            <c-col xs="auto">
              <c-input-group class="mb-2">
                <span cInputGroupText><svg cIcon class="me-2" name="cil-dialpad"></svg></span>
                <select aria-label="Choose the Number of Workers Visible" (change)="updateFilter()" name="pagesize" cSelect [(ngModel)]="pagesize">
                  <option value="5">{{ t('Up to 5 Workers') }}</option>
                  <option value="10">{{ t('Up to 10 Workers') }}</option>
                  <option value="15">{{ t('Up to 15 Workers') }}</option>
                  <option value="20">{{ t('Up to 20 Workers') }}</option>
                  <option value="25">{{ t('Up to 25 Workers') }}</option>
                </select>
              </c-input-group>
            </c-col>
            <c-col xs="auto">
              <c-input-group class="mb-2">
                <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                  <option value="status">{{ t('Status') }}</option>
                  <option value="newest">{{ t('Newest') }}</option>
                  <option value="oldest">{{ t('Oldest') }}</option>
                  <option value="name">{{ t('Name') }}</option>
                </select>
              </c-input-group>
            </c-col>
            <c-col xs="auto" class="text-end justify-content-end">
              <button cButton class="btn btn-light mb-2" (click)="getWorkers(false)"><i class="fa-solid fa-arrows-rotate"></i>
              <span class=" d-none d-lg-inline">
                {{ t('Refresh') }} <countdown #cd  [config]="config"></countdown>
                </span>
              </button>
            </c-col>
          </div>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-lg-12 col-md-6 col-sm-12 text-center">
          <div class="btn-group btn-group-md m-2" role="group" aria-label="Basic example">


            <button class="btn btn-secondary d-none d-lg-inline" disabled>{{ t('View') }}</button>

            <button type="button" class="btn " [class.btn-outline-secondary]="view!='full'" [class.btn-info]="view=='full'" (click)="changeView('full')">
              <i class="fa-solid fa-table-cells-large"></i> {{ t('Full') }}
            </button>
            <button type="button" class="btn " [class.btn-outline-secondary]="view!='mini'" [class.btn-info]="view=='mini'" (click)="changeView('mini')">
              <i class="fa-solid fa-table-cells"></i> {{ t('Mini') }}
            </button>
            <button type="button" class="btn " [class.btn-outline-secondary]="view!='row'" [class.btn-info]="view=='row'" (click)="changeView('row')">
              <i class="fa-solid fa-table-list"></i> {{ t('Row') }}
            </button>
            <button type="button" class="btn " [class.btn-outline-secondary]="view!='map'" [class.btn-info]="view=='map'" (click)="changeView('map')">
              <i class="fa-solid fa-map-location"></i> {{ t('Map') }}
            </button>
          </div>
        </div>
        </div>

            <hr/>



            <ng-container *ngIf="workers">

              <ng-container *ngIf="view=='full'">

              <div class= "row mt-1 " *ngFor="let worker of workers">
                <div class="col ">
                    <div class="card">
                        <div class="card-header worker-card-header"
                        [class.bg-danger]="worker.status.status=='Help' || worker.status.status=='Overdue' || worker.status.status=='Man Down' || (worker.status.fall_detection && worker.status.fall_detection.active_fall)"
                        [class.bg-success]="worker.status.status=='Working'"
                        [class.text-white]="worker.status.status=='Help' || worker.status.status=='Working' || worker.status.status=='Overdue' || worker.status.status=='Man Down'"
                        >

                          <div class="row justify-content-between">
                            <div class="col-md-auto">
                                <h3 routerLink="/mgmt/worker/{{worker.id}}" class="pointer"><span class="badge bg-light text-dark">{{ u.formatWorkerPin(worker.pin) }}</span> {{worker.name}}</h3>
                            </div>
                            <div class="col-sm-2 text-start">
                                    <b>{{worker.status.status_str}}</b>
                            </div>
                            <div class="col-sm-2 text-end">
                                 <button type="button" class="btn btn-light btn-sm pointer" routerLink="/mgmt/worker/{{worker.id}}" routerLinkActive="active"><i class="fas fa-edit"></i> {{ t('Edit') }} </button>
                            </div>
                          </div>

                        </div>
                        <div class="card-body px-2">
                            <div class="row">
                            <div class="col-sm-12 col-md-7 col-md-8 ">
                                        <div class="row" *ngIf="worker.status.working">

                                            <div class="col">

                                              

                                                <div class="alert alert-danger" role="alert" *ngIf="worker.status.fall_detection && worker.status.fall_detection.active_fall">
                                                {{ t('Fall Detected at') }} {{worker.status.fall_detection.fall_detection_time_local }}
                                                </div>

                                                <div class="alert alert-success" role="alert" *ngIf="worker.status.checkin_due=='' && (worker.status.status == 'Working' || worker.status.status == 'Ok') && !(worker.status.fall_detection && worker.status.fall_detection.active_fall)">
                                                  {{ t('On shift with monitoring') }}
                                                </div>

                                                @if(worker.status.checkin_due!='' && (worker.status.status == 'Working' || worker.status.status == 'Ok')){
                                                  @if(worker.status.highrisk){ 
                                                    <div class="alert alert-warning" role="alert">
                                                      <i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk') }} {{ t('Check In due in') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                                                    </div>
                                              

                                                  }
                                                  @else{
                                                    <div class="alert alert-success" role="alert" *ngIf="worker.status.checkin_due!='' && (worker.status.status == 'Working' || worker.status.status == 'Ok')">
                                                      {{ t('Check In due in') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                                                    </div>
                                                  }
                                                }

                                                <div class="alert alert-warning" role="alert" *ngIf="worker.status.mandown.alert">
                                                  {{ t('The worker has not moved since') }} {{ worker.status.mandown.time_str_local }}
                                                </div>

                                                <div class="alert alert-danger" role="alert" *ngIf="worker.status.status == 'Help'">
                                                  {{ t('Help signal sent at') }} {{worker.status.help_time_local }}
                                                </div>
                                                

                                                <div class="alert alert-danger" role="alert" *ngIf="worker.status.status == 'Overdue'">
                                                  <span *ngIf="worker.status.highrisk"><i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk') }} </span>{{ t('Check In overdue by') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                                                </div>


                                                <div class="d-grid gap-2" *ngIf="worker.alert">
                                                    <button class="btn btn-danger text-white mb-1" type="button" routerLink="/reports/alert/{{worker.alert.id}}"><i class="fa-solid fa-triangle-exclamation"></i> {{ t('View Alert') }}</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-2" *ngIf="worker.status.working">
                                            <div class="col text-center">
                                                <button type="button" class="btn btn-outline-secondary m-1" (click)="manualCheckIn(worker.id)"><i class="fa-solid fa-check"></i> {{ t('Check In') }}</button>

                                                <button type="button" class="btn btn-outline-secondary  m-1" (click)="manualEndShift(worker.id)"><i class="fa-solid fa-xmark"></i> {{ t('End Shift') }}</button>

                                                <button *ngIf="worker.status.mandown.on" type="button" class="btn btn-outline-secondary  m-1" (click)="manualManDown(worker.id)"><i class="fa-solid fa-child-reaching"></i> {{ t('Man Down Ok') }}</button>

                                                <button  *ngIf="worker.shift" type="button" class="btn btn-outline-secondary  m-1"  routerLink="/mgmt/shift/{{worker.shift.id}}"><i class="fa-solid fa-map-pin"></i>
                                                  <span *ngIf="!worker.status.working"> {{ t('View Last Shift') }}</span>
                                                  <span *ngIf="worker.status.working"> {{ t('View Shift') }}</span>
                                                </button>

                                            </div>
                                        </div>



                                    @if(worker.status.activity){
                                      <div class="row">
                                        <div class="col">
                                          <div class="card mb-2">
                                            <div class="card-body p-2 m-0">

                                                <div class="row">
                                                  <div class="col-sm-auto text-center align-self-center">
                                                    <span class="badge text-bg-info text-white fs-5"><i class="fa-solid fa-hourglass-half"></i> Timed Activity</span>
                                                  </div>
                                                  <div class="col-sm-auto">
                                                    <p class="p-0 m-0">
                                                      <b class="fs-5">{{worker.status.activity.name}} </b>
                                                      <span class="badge text-bg-warning" *ngIf="worker.status.activity.overdue">Overdue</span>
                                                      <br/>
                                                      <i class="fa-solid fa-play text-success"></i> {{worker.status.activity.start_at_local}}
                                                      <i class="fa-solid fa-flag-checkered text-danger"></i> {{worker.status.activity.end_at_local}}
                                                    </p>
                                                  </div>
                                                  <div class="col text-center align-self-center">
                                                    <button type="button" class="btn btn-outline-secondary btn-sm m-1" (click)="extendActivity(worker.status.activity.id)"><i class="fa-solid fa-clock"></i> {{ t('Extend Activity') }}</button>

                                                    <button type="button" class="btn btn-outline-secondary btn-sm  m-1" (click)="completeActivity(worker.status.activity.id)"><i class="fa-solid fa-check"></i> {{ t('Complete Activity') }}</button>
                                                  </div>
                                                </div>

                                              <div>


                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }


                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 col-sm-12 table-responsive">

                                <table class="table table-striped table-sm">
                                  <tbody>
                                  <!-- <tr><th class="text-end">{{ t('Name') }}</th><td>{{worker.name}}</td></tr> -->
                                  <tr *ngIf="worker.phone"><th class="text-end">{{ t('Phone') }}</th><td>{{worker.phone}}</td></tr>
                                  <tr *ngIf="worker.cell"><th class="text-end">{{ worker.zoleo ? t('ZOLEO Number') : t('Alt Phone') }}</th><td>{{worker.cell}}</td></tr>
                                  <tr *ngIf="worker.email"><th class="text-end">{{ t('Email') }}</th><td>{{worker.email}}</td></tr>
                                  <tr><th class="text-end">{{ t('Monitors') }}</th><td>
                                    <ng-container *ngFor="let monitor_name of worker.monitor_names; let i = index">
                                      <span class="pointer" routerLink="/mgmt/monitor/{{worker.monitors[i]}}">{{ monitor_name }}&nbsp;&nbsp;</span>
                                    </ng-container>
                                  </td></tr>
                                  <tr *ngIf="worker.group_names.length > 0 && okService.hasFeature('groups')"><th class="text-end">{{ t('Groups') }}</th><td>
                                    <ng-container *ngFor="let group_name of worker.group_names; let i = index">
                                      <span class="pointer" routerLink="/mgmt/group/{{worker.group_ids[i]}}">{{ group_name }}&nbsp;&nbsp;</span>
                                    </ng-container>
                                  </td></tr>
                                  <tr *ngIf="worker.alert_loop_name"><th class="text-end">{{ t('Alert Loop') }}</th><td>
                                      <span class="pointer" routerLink="/mgmt/alertloop/{{worker.alert_loop}}">{{ worker.alert_loop_name }}&nbsp;&nbsp;</span>
                                  </td></tr>
                                </tbody>

                                </table>


                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12 table-responsive">


                                        <table class="table table-striped table-sm">
                                          <tbody>
                                            <tr><th class="text-end">{{ t('Check In') }}</th><td>{{u.minsToString(worker.check_in_freq)}}</td></tr>
                                            
                                            <tr *ngIf="worker.arc && worker.arc.active"><th class="text-end">{{ t('Safety Monitoring Center') }}</th><td>
                                              @if(worker.arc.valid.valid){
                                                <span class="badge text-bg-success text-white" routerLink="/mgmt/worker/{{worker.id}}">Active</span>
                                              }
                                              @else{
                                                <span class="badge text-bg-warning text-white" routerLink="/mgmt/worker/{{worker.id}}">Inactive</span>
                                              }
                                            </td></tr>

                                          <ng-container *ngIf="worker.status.mandown && okService.hasFeature('mandown')">

                                                  <!-- Man Down Settings -->
                                                  <tr *ngIf="worker.status.mandown.on">
                                                      <th class="text-end">{{ t('Man Down') }}</th><td>{{ t('On') }} ({{worker.status.mandown.mins_str}})</td>
                                                  </tr>
                                                  <tr *ngIf="worker.status.mandown.time_str_local">
                                                      <th class="text-end">{{ t('Last Movement') }}</th><td>{{worker.status.mandown.time_str_local}}</td>
                                                  </tr>
                                                  <tr *ngIf="!worker.status.mandown.on">
                                                    <th class="text-end">{{ t('Man Down') }}</th><td>{{ t('Off') }}</td>
                                                  </tr>

                                              </ng-container>

                                              <ng-container *ngIf="okService.hasFeature('fall_detection',false) && worker.status.fall_detection">
                                                <tr>
                                                  <th class="text-end">{{ t('Fall Detection') }}</th><td>
                                                    {{worker.status.fall_detection && worker.status.fall_detection.on ? t('On') : t('Off')}}
                                                  </td>
                                              </tr>
                                              </ng-container>

                                              @if(okService.hasFeature('app_connectivity')){
                                                  <ng-container *ngIf="worker.status.working && worker.connectivity">
                                                    
                                                    <tr>
                                                      <th class="text-end">{{ t('Device') }}</th>
                                                      <td>
                                                        {{ worker.connectivity.device }}
                                                      </td>
                                                    </tr>
                                                    <tr class="cursor-pointer" routerLink="/reports/worker-reports/app-connectivity" style="cursor: pointer;">
                                                      <th class="text-end">{{ t('Connectivity') }}</th>
                                                      <td>
                                                        <div class="d-flex flex-wrap gap-2 align-items-center">
                                                          <div *ngIf="worker.connectivity.status">
                                                            <c-badge [color]="worker.connectivity.status.class">
                                                              {{ worker.connectivity.status.identifier }}
                                                            </c-badge>
                                                          </div>
                                                          <div *ngIf="worker.connectivity.device == 'Android' && worker.connectivity.signal?.strength">
                                                            <c-badge [color]="worker.connectivity.signal.color">
                                                              <i class="fa-solid fa-signal me-1"></i> {{ worker.connectivity.signal.label }}
                                                            </c-badge>
                                                          </div>
                                                          <div *ngIf="worker.connectivity.battery?.percentage !== undefined">
                                                            <c-badge [color]="worker.connectivity.battery.color">
                                                              <i class="fa-solid fa-battery-half me-1"></i>{{ worker.connectivity.battery.label }}
                                                            </c-badge>
                                                          </div>
                                                          <!-- <div *ngIf="motionHeartbeatVisible(worker.connectivity.motion_heartbeat)">
                                                            <span
                                                              [attr.title]="(worker.connectivity.motion_heartbeat.time || '') + (worker.connectivity.motion_heartbeat.formatted_time_since ? (' · ' + worker.connectivity.motion_heartbeat.formatted_time_since) : '')">
                                                              <c-badge [color]="motionHeartbeatBadgeColor(worker.connectivity.motion_heartbeat.minutes_since)">
                                                                {{ motionHeartbeatLabel(worker.connectivity.motion_heartbeat) }}
                                                              </c-badge>
                                                            </span>
                                                          </div> -->
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  </ng-container>
                                                }
 
                                                  <ng-container *ngIf="okService.isGeotab() && worker.vehicle && worker.vehicle.name">
                                                  <tr>
                                                    <th class="text-end">{{ t('Vehicle') }}</th>
                                                    <td>{{worker.vehicle.name}}
                                                      <span *ngIf="worker.vehicle.driving"> <i class="fas fa-car text-success" title="{{ t('Driving') }}"></i></span>
                                                      <span *ngIf="!worker.vehicle.driving"> <i class="fas fa-car text-secondary" title="{{ t('Not Driving') }}"></i></span>
                                                    </td>
                                                  </tr>
                                                  <!-- Man Down Settings -->
                                                  <tr *ngIf="okService.settings.drive_mode">
                                                      <th class="text-end">{{ t('Drive Mode') }}</th><td>
                                                        <span *ngIf="worker.drive_mode"> {{ t('On') }}</span>
                                                        <span *ngIf="!worker.drive_mode"> {{ t('Off') }}</span>
                                                      </td>
                                                  </tr>
                                                  </ng-container>
                                                </tbody>
                                        </table>

                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">



                                          <div class="card">
                                              <div class="card-header" id="headingInfoTwo{{worker.id}}">
                                                <h6 class="mb-0" type="button" data-bs-toggle="collapse" attr.data-bs-target="#workerInfo{{worker.id}}" aria-expanded="false" attr.aria-controls="workerInfo{{worker.id}}">
                                                      <i class="fas fa-info-circle"></i>  {{ t('OK Alone Info') }} <span class="d-none d-sm-inline"> {{ t('for') }} {{worker.name}}</span>
                                                </h6>
                                              </div>
                                              <div id="workerInfo{{worker.id}}" class="collapse">
                                                  <div class="card-body">
                                                      {{ t('OK Alone can be used by your workers in the following ways:') }}<br />
                                                      <p>
                                                        <i class="fas fa-mobile-alt"></i> &nbsp;&nbsp; <b>{{ t('OK Alone App') }}</b><br />
                                                        {{ t('The worker can download the OK Alone app for') }} <a href="https://play.google.com/store/apps/details?id=com.trustyox.okalone" target="_new">Android</a> {{ t('or') }} <a href="https://itunes.apple.com/gb/app/ok-alone/id777464303" target="_new">iPhone</a> {{ t('and log in with the PIN') }} <b>{{ u.formatWorkerPin(worker.pin) }}</b>. {{ t('They can then use OK Alone to manage their shift, status and their location can be monitored in case of emergency.') }} <button type="button" *ngIf="worker.phone" (click)="okService.sendworkerSms(worker.id)" class="btn btn-outline-primary btn-sm">{{ t('Send Welcome Message') }}</button>
                                                    </p>
                                                      </div>

                                              </div>
                                          </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">


                                            <!-- <div class="accordion mb-3" id="accordionMessage{{worker.id}}" *ngIf="worker.messages.length > 0">
                                                <div class="card">
                                                    <div class="card-header" id="headingTwo{{worker.id}}">
                                                    <h5 class="mb-0">
                                                        <button class="btn btn-link collapsed" type="button" data-toggle="collapse" attr.data-target="#collapseTwo{{worker.id}}" aria-expanded="false" aria-controls="collapseTwo">
                                                                <i class="fas fa-comments"></i>  Messages <span class="d-none d-sm-inline"> from {{worker.name}}
                                                                </span>
                                                        </button>
                                                    </h5>
                                                    </div>
                                                    <div id="collapseTwo{{worker.id}}" class="collapse" attr.aria-labelledby="headingTwo{{worker.id}}" attr.data-parent="#accordionMessage{{worker.id}}">
                                                    <div class="card-body">

                                                            <div class="card mb-1" *ngFor="let message of worker.messages">

                                                                    <div class="card-body" >
                                                                        <p>{{message.text}}<i> - {{message.created_at_str}}</i></p>
                                                                    </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                </div> -->



                                        </div>
                                    </div>


                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-4">

                                    <div class="row">

                                        <div class="col text-center">

                                          

                                          @if(worker.status.working){


                            <!-- Show worker map if we have a location and vehicle location not toggled on -->
                            <div *ngIf="worker.status.loc_lat && !(map_vehicle && worker.vehicle)">
                              <!-- 
                              <img 
                              loading="lazy" 
                              [src]="worker.status.map"  
                              class="rounded img-fluid worker-map"  
                              alt="{{ t('This map shows the location of all workers who are currently on shift') }} {{worker.name}}" />
                              -->

                                <img 
                                src="https://okalone.net/images/no-location.png"
                                [lazyStaticMap]="buildMapUrl(worker.status.map)"
                                class="rounded img-fluid worker-map"  
                                alt="{{ t('This map shows the location of all workers who are currently on shift') }} {{worker.name}}" />
                                
                                <br/>
                                <p class="fw-light" *ngIf="worker.status.loc_time"><i class="fa-solid fa-location-dot text-warning"></i> &nbsp;<a href="https://www.google.com/maps/search/?api=1&query={{worker.status.loc_lat}},{{worker.status.loc_lng}}" target="_new">{{ t('Last Known Location:') }} </a> {{ t('at') }} {{ (worker.status.loc_time_local)  }}</p>
                            </div>
                            @if(!worker.status.loc_lat && worker.status.privacy_mode &&  !(map_vehicle && worker.vehicle)){
                            <!-- Show no worker map available if no worker location and  vehicle location not toggled on -->
                            <div>
                              <img 
                              src="https://okalone.net/images/privacy-mode-location.png"
                              class="rounded img-fluid worker-map"  
                              alt="{{ t('This map shows the location of all workers who are currently on shift') }} {{worker.name}}" />
                              
                            </div>
                            }
                            @else if(!worker.status.loc_lat && !(map_vehicle && worker.vehicle)){
                            <!-- Show no worker map available if no worker location and  vehicle location not toggled on -->
                            <div>
                              <i class="fa-solid fa-location-dot text-warning"></i> &nbsp;
                              <b>{{ t("No Location Available") }}</b>
                            </div>
                          }

                          <ng-container *ngIf="okService.isGeotab()">
                          <!-- Show vehicle location if we have one and it is toggled on -->
                          <div *ngIf="worker.vehicle && (worker.vehicle && worker.vehicle.loc_lat && map_vehicle)">
                            <img loading="lazy" [src]="worker.vehicle.map"  class="rounded img-fluid worker-map"  alt="{{ t('Last Known Vehicle Location') }} {{worker.name}}"/><br/>
                            <p class="fw-light" *ngIf="worker.vehicle && worker.vehicle.loc_time"><i class="fa-solid fa-location-dot text-primary"></i> &nbsp;<a href="https://www.google.com/maps/search/?api=1&query={{worker.vehicle.loc_lat}},{{worker.vehicle.loc_lng}}" target="_new">{{ t('Last Known Vehicle Location') }} </a> {{ t('at') }} {{ (worker.vehicle.loc_time_local)  }}</p>
                    </div>

                    <div *ngIf="worker.vehicle && (worker.vehicle && !worker.vehicle.loc_lat && map_vehicle)">
                      <i class="fa-solid fa-location-dot text-primary"></i> &nbsp;
                      <b>{{ t('No Location') }}</b>
                    </div>

                    <button type="button" class="btn btn-outline-secondary btn-sm mt-1" *ngIf="worker.status.map && worker.vehicle && worker.vehicle.map" (click)="map_vehicle=!map_vehicle">{{ t('Toggle Location Map') }}</button>
                          </ng-container>

                          <c-row class="text-center" *ngIf="okService.settings && okService.settings.w3w && worker.status.loc_lat">
                            <c-col>
                              <img src="/assets/images/what3words-icon-small.png" alt="what3words" height="15px"> what3words:
                              <button type="button" class="btn btn-link inline p-0 m-0" *ngIf="!worker.w3w" (click)="whatWords(worker)">{{ t('Get location') }}</button>
                              <a color="black" *ngIf="worker.w3w" href="{{worker.w3w.map}}" target="_w3w">{{worker.w3w.words}}</a>
                            </c-col>
                          </c-row>

                          
                          }


                          <div class="card m-0 mb-1 mt-2" *ngIf="worker.message">
                            <div class="card-body m-0 p-2">
                              <i class="fa-regular fa-message"></i> &nbsp;&nbsp;  <b>Last Message: </b>
                              <span *ngIf="worker.message.type=='message'">{{worker.message.msg}}</span>
                              <span *ngIf="worker.message.type=='voice_message'"><a href="{{worker.message.msg}}" target="_new">Listen Now</a></span>
                              <span class="fw-light"> at {{worker.message.time}}</span><br/>
                              <button type="button" class="btn btn-outline-secondary btn-sm ml-2"  routerLink="/mgmt/worker/messages/{{worker.id}}">{{ t('View Messages') }}</button>
                            </div>
                          </div>

                            </div></div>


                            </div>
                          </div>
                        </div>
                      </div>

                </div>

                </div>

              </ng-container>

              <ng-container *ngIf="view=='row'">

                <table class="table table-striped">

                <tbody>
                  <tr *ngFor="let worker of workers">
                    <td style="max-width:150px;"><h3 *ngIf="worker.status.status!='Not Working'"><span class="badge"
                      [class.bg-danger]="worker.status.status=='Help' || worker.status.status=='Overdue' || worker.status.status=='Man Down' || (worker.status.fall_detection && worker.status.fall_detection.active_fall)"
                        [class.bg-success]="worker.status.status=='Working'"
                        [class.text-white]="worker.status.status=='Help' || worker.status.status=='Working' || worker.status.status=='Overdue' || worker.status.status=='Man Down'"
                      >{{worker.status.status}}</span></h3></td>

                    <td style="max-width:300px;"><h4 routerLink="/mgmt/worker/{{worker.id}}" class="pointer"><span class="badge bg-light text-dark">{{ u.formatWorkerPin(worker.pin) }}</span> {{worker.name}}</h4></td>
                    <td class="fs-5">
                      <div  *ngIf="worker.status.status == 'Working' || worker.status.status == 'Ok'">

                        <div *ngIf="worker.status.checkin_due!=''">
                          <span *ngIf="worker.status.highrisk"><i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk') }} </span>{{ t('Check In due in') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                        </div>
                        <div *ngIf="worker.status.checkin_due==''">
                          {{ t('On shift with monitoring') }}
                        </div>


                    </div>

                    <div  *ngIf="worker.status.mandown.alert">
                      {{ t('The worker has not moved since') }} {{ worker.status.mandown.time_str_local }}
                    </div>

                    <div  *ngIf="worker.status.status == 'Help'">
                      {{ t('Help signal sent at') }} {{worker.status.help_time_local }}
                    </div>

                    <div  *ngIf="worker.status.status == 'Working' && worker.status.fall_detection && worker.status.fall_detection.active_fall">
                      {{ t('Fall Detected at') }} {{worker.status.fall_detection.fall_detection_time_local }}
                    </div>


                    <div  *ngIf="worker.status.status == 'Overdue'">

                      <span *ngIf="worker.status.highrisk"><i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk') }} </span>{{ t('Check In overdue by') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                    </div>

                    </td>
                    <td class="text-end">

                      <button type="button" class="btn btn-light" routerLink="/mgmt/worker/{{worker.id}}" routerLinkActive="active"><i class="fas fa-edit"></i>{{ t('Edit') }}</button>
                    </td>
                  </tr>
                </tbody>
                </table>

              </ng-container>

              <ng-container *ngIf="view=='mini'">

                <div class="row">

                  <ng-container *ngFor="let worker of workers">
                    <div class="col-md-4 col-sm-6">
                      <div class="card m-1">
                          <div class="card-header"
                          [class.bg-danger]="worker.status.status=='Help' || worker.status.status=='Overdue' || worker.status.status=='Man Down' || (worker.status.fall_detection && worker.status.fall_detection.active_fall)"
                          [class.bg-success]="worker.status.status=='Working'"
                          [class.text-white]="worker.status.status=='Help' || worker.status.status=='Working' || worker.status.status=='Overdue' || worker.status.status=='Man Down'"
                          >

                            <div class="row">
                              <div class="col-12">
                                  <h4 routerLink="/mgmt/worker/{{worker.id}}" class="pointer"><span class="badge bg-light text-dark">{{ u.formatWorkerPin(worker.pin) }}</span> {{worker.name}}</h4>
                              </div>
                              <div class="col-md-12 text-start">
                                      <b>{{worker.status.status_str}}</b>
                              </div>
                            </div>

                          </div>
                          <div class="card-body px-2">
                            <div *ngIf="worker.phone || worker.cell" class="text-center">
                              <p>
                                <i class="fa-solid fa-phone"></i>
                                {{worker.phone}}
                                <span *ngIf="worker.phone && worker.cell">/</span>
                                {{worker.cell}}
                              </p>

                              <ng-container *ngIf="okService.isGeotab() && worker.vehicle && worker.vehicle.name">
                                <div class="row">
                                  <div class="col">
                                    <span class="text-end"><b>{{ t('Vehicle') }}</b></span>
                                    <div>{{worker.vehicle.name}}
                                      <span *ngIf="worker.vehicle.driving"> <i class="fas fa-car text-success" title="{{ t('Driving') }}"></i></span>
                                      <span *ngIf="!worker.vehicle.driving"> <i class="fas fa-car text-secondary" title="{{ t('Not Driving') }}"></i></span>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col">
                                    <div *ngIf="okService.settings.drive_mode">

                                      <span class="text-end"><b>{{ t('Drive Mode') }}</b></span>
                                      <span *ngIf="worker.drive_mode"> {{ t('On') }}</span>
                                      <span *ngIf="!worker.drive_mode"> {{ t('Off') }}</span>

                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>



                          <div [ngClass]="{'alert-warning': worker.status.highrisk, 'alert-success': !worker.status.highrisk}" class="alert text-center" role="alert" *ngIf="(worker.status.status == 'Working' || worker.status.status == 'Ok') && !(worker.status.fall_detection && worker.status.fall_detection.active_fall)">

                            <div *ngIf="worker.status.checkin_due!=''">
                              <span *ngIf="worker.status.highrisk"><i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk') }} </span>{{ t('Check In due in') }} {{ worker.status.checkin_due_mins_str  }} {{ t('at') }} {{ worker.status.checkin_due_local  }}
                            </div>
                            <div *ngIf="worker.status.checkin_due==''">
                              {{ t('On shift with monitoring') }}
                            </div>
                          </div>

                          <div class="alert alert-warning text-center" role="alert" *ngIf="worker.status.mandown.alert">
                            {{ t('Possible Man Down') }}
                          </div>

                          <div class="alert alert-danger text-center" role="alert" *ngIf="worker.status.status == 'Help'">
                              {{ t('Help Requested') }}
                          </div>

                          <div class="alert alert-danger text-center" role="alert" *ngIf="worker.status.fall_detection && worker.status.fall_detection.active_fall">
                            {{ t('Fall Detected') }}
                        </div>

                          <div class="alert alert-danger text-center" role="alert" *ngIf="worker.status.status == 'Overdue'">
                            <span *ngIf="worker.status.highrisk"><i class="fa-solid fa-triangle-exclamation text-warning"></i> {{ t('High Risk Check In overdue by') }}</span>
                            <span *ngIf="!worker.status.highrisk">{{ t('Check In overdue by') }}</span>
                               {{ worker.status.checkin_due_mins_str  }}
                          </div>


                          <div class="d-grid gap-2" *ngIf="worker.alert">
                            <button class="btn btn-danger btn-sm text-white mb-1" type="button" routerLink="/reports/alert/{{worker.alert.id}}"><i class="fa-solid fa-triangle-exclamation"></i> {{ t('View Alert') }}</button>
                        </div>

                        @if(worker.status.working){

                        <div class="text-center">
                          <!-- <div *ngIf="worker.status.loc_time">
                                <img loading="lazy" [src]="worker.status.map"  class="rounded img-fluid worker-map"  alt="{{ t('Last Known Location:') }} {{worker.name}}" /><br/>
                          </div>
                          <div *ngIf="!worker.status.loc_time">
                              <i class="fa-solid fa-location-dot text-warning"></i>
                              <b> {{ t("No Location Available") }}</b>
                          </div> -->

                          

                          <!-- Show worker map if we have a location and vehicle location not toggled on -->
                          <div *ngIf="worker.status.loc_lat && !(map_vehicle && worker.vehicle)">
                            <img 
                            src="https://okalone.net/images/no-location.png"
                            [lazyStaticMap]="buildMapUrl(worker.status.map)"
                            class="rounded img-fluid worker-map"  
                            alt="{{ t('This map shows the location of all workers who are currently on shift') }} {{worker.name}}" />
                            
                            <br/>
                            <p class="fw-light" *ngIf="worker.status.loc_time"><i class="fa-solid fa-location-dot text-warning"></i> &nbsp;<a href="https://www.google.com/maps/search/?api=1&query={{worker.status.loc_lat}},{{worker.status.loc_lng}}" target="_new">{{ t('Last Known Location:') }} </a> {{ t('at') }} {{ (worker.status.loc_time_local)  }}</p>
                          </div>
                          <!-- Show no worker map available if no worker location and  vehicle location not toggled on -->
                          <div *ngIf="!worker.status.loc_lat && !(map_vehicle && worker.vehicle)">
                            <i class="fa-solid fa-location-dot text-warning"></i> &nbsp;
                            <b>{{ t("No Location Available") }}</b>
                          </div>

                          <div *ngIf="worker.status.loc_time" class="text-center">
                            <!-- <p class="fw-light"><i class="fa-solid fa-location-dot text-warning"></i> {{ t('Last Location') }} {{ t('at') }} {{ (worker.status.loc_time_local)  }}  <a href="https://www.google.com/maps/search/?api=1&query={{worker.status.loc_lat}},{{worker.status.loc_lng}}" target="_new" class="text-secondary"><i class="fa-solid fa-arrow-up-right-from-square"></i></a></p> -->

                            <ng-container *ngIf="okService.isGeotab()">
                              <!-- Show vehicle location if we have one and it is toggled on -->
                              <div *ngIf="worker.vehicle && (worker.vehicle && worker.vehicle.loc_lat && map_vehicle)">
                                <img loading="lazy" [src]="worker.vehicle.map"  class="rounded img-fluid worker-map"  alt="{{ t('Last Known Vehicle Location') }} {{worker.name}}"/><br/>
                                <p class="fw-light" *ngIf="worker.vehicle && worker.vehicle.loc_time"><i class="fa-solid fa-location-dot text-primary"></i> &nbsp;<a href="https://www.google.com/maps/search/?api=1&query={{worker.vehicle.loc_lat}},{{worker.vehicle.loc_lng}}" target="_new">{{ t('Last Known Vehicle Location') }} </a> {{ t('at') }} {{ (worker.vehicle.loc_time_local)  }}</p>
                              </div>

                              <div *ngIf="worker.vehicle && (worker.vehicle && !worker.vehicle.loc_lat && map_vehicle)">
                                <i class="fa-solid fa-location-dot text-primary"></i> &nbsp;
                                <b>{{ t('No Location') }}</b>
                              </div>

                              <button type="button" class="btn btn-outline-secondary btn-sm mt-1" *ngIf="worker.status.map && worker.vehicle && worker.vehicle.map" (click)="map_vehicle=!map_vehicle">{{ t('Toggle Location Map') }}</button>
                            </ng-container>

                            <c-row class="text-center" *ngIf="okService.settings && okService.settings.w3w && worker.status.loc_lat">
                              <c-col>
                                <img loading="lazy" src="/assets/images/what3words-icon-small.png" alt="what3words" height="15px"> what3words:
                                <button type="button" class="btn btn-link inline m-0 p-0" *ngIf="!worker.w3w" (click)="whatWords(worker)">{{ t('Get location') }}</button>
                                <a color="black" *ngIf="worker.w3w" href="{{worker.w3w.map}}" target="_w3w">{{worker.w3w.words}}</a>
                              </c-col>
                            </c-row>
                          </div>

                        </div>
                        }


                      <c-row class="text-center">
                        <c-col>
                          <div class="btn-group" role="group">
                            <button type="button" class="btn btn-sm btn-outline-secondary"  *ngIf="worker.status.working && worker.status.checkin_due!=''" (click)="manualCheckIn(worker.id)"><i class="fa-solid fa-check"></i> {{ t('Check In') }}</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary"  *ngIf="worker.status.working" (click)="manualEndShift(worker.id)"><i class="fa-solid fa-xmark"></i> {{ t('End Shift') }}</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" routerLink="/mgmt/worker/{{worker.id}}" routerLinkActive="active"><i class="fas fa-edit"></i> {{ t('Edit') }}
                            </button>
                          </div>
                      </c-col>
                    </c-row>

                          </div>
                        </div>
                      </div>

                  </ng-container>

                </div>


              </ng-container>

            </ng-container>


            <ng-container *ngIf="view=='map'">
              <app-locations></app-locations>
            </ng-container>

            <c-row class="justify-content-end" *ngIf="view!='map' && pagination.totalPages>1">

              <c-col xs="auto" class="mt-2" *ngIf="pagination.totalPages > 1">
                <c-input-group  class="text-end">
                  <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                  <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                    <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                  </select>
                </c-input-group>
              </c-col>

            </c-row>

    </c-card-body>
  </c-card>
